import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';

export const HookedSubmitButton = (props: ChakraV3.ButtonProps) => {
  const { children, ...rest } = props;
  const { formState } = useFormContext();

  return (
    <ChakraV3.Button
      type='submit'
      loading={formState.isSubmitting}
      colorPalette='brand'
      size='sm'
      disabled={!formState.isDirty}
      {...rest}
    >
      {children}
    </ChakraV3.Button>
  );
};
